<template>
  <b-row class="text-center">
    <div class="form-group col-lg-12 col-sm-12">
      <div class="input-group">
        <span class="input-group-btn">
          <router-link v-if="this.$can('user', 'create')" :to="{name: 'Add User'}" class="btn btn-primary">Add+</router-link>
        </span>
        <input type="text" v-model="filterText" class="form-control" @keyup.enter="doFilter" placeholder="Name" autofocus>
        <span class="input-group-btn">
          <button type="button" class="btn btn-primary"  @click.prevent="doFilter">Search</button>
          <button type="button" class="btn btn-primary"  @click.prevent="resetFilter">Clear</button>          
        </span>
      </div>
    </div>
  </b-row>
</template>

<script>
export default {
  data() {
    return {
      filterText: '',
    }
  },
  methods: {
    doFilter() {
      this.$events.fire('filter-set', this.filterText)
    },
    resetFilter() {
      this.filterText = ''
      this.$events.fire('filter-reset')
    },
    newUser() {
      console.log('Message #: 12890')
    },
  }
}
</script>
